export const toLocaleNumber = (locale, number, decimal = 2) => {
  if (Number.isNaN(Number(number))) {
    number = 0;
  }

  return Number(number).toLocaleString(locale, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal
  });
};